<!--
  Angular 15: *ngIf / *ngFor only, no @if blocks.
-->
<div class="cat-dialog-backdrop" *ngIf="isOpen" (click)="close()">
  <form
    class="cat-dialog"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="isEdit ? 'Edit catalog' : 'New catalog'"
    cdkTrapFocus
    [cdkTrapFocusAutoCapture]="isOpen"
    (click)="$event.stopPropagation()"
    (ngSubmit)="save()"
    data-testid="catalog-form">

    <h2 class="cat-dialog__title">{{ isEdit ? 'Edit catalog' : 'New catalog' }}</h2>

    <div class="cat-dialog__fields">
      <div class="dl-field">
        <label class="dl-field__label" for="catalogCode">Code *</label>
        <input id="catalogCode" name="code" class="dl-input" [(ngModel)]="code"
               maxlength="64" placeholder="e.g. IVOCLAR-2026" autocomplete="off"
               [disabled]="saving" data-testid="catalog-form-code" />
        <span class="dl-field__error" *ngIf="codeInvalid">Letters, digits and _ . - only</span>
        <span class="dl-field__hint" *ngIf="!codeInvalid">Stored in upper case.</span>
      </div>

      <div class="dl-field">
        <label class="dl-field__label" for="catalogName">Name *</label>
        <input id="catalogName" name="name" class="dl-input" [(ngModel)]="name"
               maxlength="255" autocomplete="off" [disabled]="saving" data-testid="catalog-form-name" />
      </div>

      <div class="dl-field">
        <label class="dl-field__label" for="catalogDescription">Description</label>
        <textarea id="catalogDescription" name="description" class="dl-input" [(ngModel)]="description"
                  maxlength="1000" [disabled]="saving" data-testid="catalog-form-description"></textarea>
      </div>

      <div class="dl-field">
        <label class="dl-field__label" for="catalogSource">Source (URL)</label>
        <input id="catalogSource" name="sourceUrl" type="url" class="dl-input" [(ngModel)]="sourceUrl"
               maxlength="1000" placeholder="https://" autocomplete="off" [disabled]="saving"
               data-testid="catalog-form-source" />
      </div>
    </div>

    <div class="dl-banner dl-banner--error cat-dialog__error" *ngIf="error">
      <mat-icon>error</mat-icon>
      <div class="dl-banner__body">{{ error }}</div>
    </div>

    <div class="cat-dialog__actions">
      <button type="button" class="dl-btn" [disabled]="saving" (click)="close()">Cancel</button>
      <button type="submit" class="dl-btn dl-btn--primary" [disabled]="!canSave" data-testid="catalog-form-save">
        {{ saving ? 'Saving…' : 'Save' }}
      </button>
    </div>
  </form>
</div>
